import EditIcon from "@/assets/images/icons/edit.svg?inline";
import LoadingIcon from "@/assets/images/icons/loading-white.svg?inline";

import {
  EDIT_IMAGE_PREFERENCES,
  UPDATE_BUYER_IMAGE_PREFERENCES
} from "../../../gql/UserProfileQueries";

export default {
  name: "image_preference",

  data() {
    return {
      imagePreferences: [],
      editingPreference: {},
      editingPreferenceValues: [],
      loadingEditedPreferences: false,
      skipEditedPreferencesQuery: true,

      checkedSelect: ""
    };
  },

  props: ["preferences", "isOwner"],

  apollo: {
    editImagePreference: {
      query: EDIT_IMAGE_PREFERENCES,
      fetchPolicy: "no-cache",
      variables() {
        return {
          tagId: this.editingPreference.tagId
        };
      },
      skip() {
        return this.skipEditedPreferencesQuery;
      },
      result(data) {
        if (this.editImagePreference.selectedValue) {
          this.checkedSelect = JSON.parse(
            this.editImagePreference.selectedValue
          );
        }
        this.$refs.modalEditImagePreference.show();
        this.skipEditedPreferencesQuery = true;
      }
    }
  },

  computed: {
    answerBadgeClass() {
      let cssClass = "col-sm-4 mb-3";

      if (this.editImagePreference.values.length > 0) {
        cssClass = `col-6 col-md-${12 /
          this.editImagePreference.values.length}`;
      } else {
        cssClass = "mb-3";
      }

      return cssClass;
    }
  },

  mounted: function() {
    this.imagePreferences = this.preferences;
  },

  methods: {
    initEditImagePreference(preference) {
      if (this.isOwner) {
        this.editingPreference = preference;

        this.skipEditedPreferencesQuery = false;
      }
    },

    hideModal() {
      this.$refs.modalEditImagePreference.hide();
      // this.isShowFilters = !this.isShowFilters;
    },

    saveEditedPreferences() {
      this.loadingEditedPreferences = true;
      this.$apollo
        .mutate({
          mutation: UPDATE_BUYER_IMAGE_PREFERENCES,
          variables: {
            tagId: this.editingPreference.tagId,
            value: JSON.stringify(this.checkedSelect)
          }
        })
        .then(({ data: { updateBuyerImagePreference: { entity } } }) => {
          let indexOfPreference = this.imagePreferences.findIndex(p => {
            return p.tagId == entity.tagId;
          });

          this.imagePreferences[indexOfPreference] = entity;
        })
        .catch(mutationError => {
          const errors = mutationError.graphQLErrors;

          for (let error in errors) {
            this.$toasted.error(errors[error].message);
          }
        })
        .finally(() => {
          this.loadingEditedPreferences = false;
          this.hideModal();
          this.editingPreference = {};
        });
    }
  },

  components: {
    EditIcon,
    LoadingIcon
  }
};
